import _objectSpread from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
import _objectWithoutProperties from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectWithoutProperties"; //@ts-check

import React from 'react';
import { FormSpy } from 'react-final-form';
import FormFieldBase from '../FieldBase';
import RepositoryPickerFormInput from '../../input/RepositoryPicker';
import getDotProp from '../../../utils/getDotProp';
/**
 * @param {import('./types').FinalFormFieldRepositoryPickerProps} props
 */

var RepositoryPickerFormField = function RepositoryPickerFormField(_ref) {
  var _ref$input = _ref.input,
      name = _ref$input.name,
      value = _ref$input.value,
      onChange = _ref$input.onChange,
      restInput = _objectWithoutProperties(_ref$input, ["name", "value", "onChange"]),
      meta = _ref.meta,
      nameWorkspace = _ref.nameWorkspace,
      workspace = _ref.workspace,
      helperText = _ref.helperText,
      required = _ref.required,
      rest = _objectWithoutProperties(_ref, ["input", "meta", "nameWorkspace", "workspace", "helperText", "required"]);

  var showError = (meta.submitError && !meta.dirtySinceLastSubmit || meta.error) && meta.touched;
  return React.createElement(FormSpy, {
    subscription: {
      values: true
    }
  }, function (_ref2) {
    var mutators = _ref2.form.mutators,
        values = _ref2.values;
    var workspaceValue = nameWorkspace ? getDotProp(values, nameWorkspace) : workspace;
    return React.createElement(RepositoryPickerFormInput, Object.assign({
      value: {
        workspace: workspaceValue,
        path: value
      },
      onChange: function onChange(_ref3) {
        var path = _ref3.path,
            workspace = _ref3.workspace;
        mutators.setValue(name, path);
        if (nameWorkspace) mutators.setValue(nameWorkspace, workspace);
      },
      textFieldProps: {
        helperText: showError ? meta.error : helperText,
        error: showError,
        required: required,
        inputProps: _objectSpread({}, restInput)
      }
    }, rest));
  });
};
/**
 * @param {import('./types').FormFieldRepositoryPickerProps} props
 */


export var RepositoryPicker = function RepositoryPicker(_ref4) {
  var name = _ref4.name,
      rest = _objectWithoutProperties(_ref4, ["name"]);

  return React.createElement(FormFieldBase, Object.assign({
    name: name,
    label: name
  }, rest));
};
RepositoryPicker.defaultProps = {
  component: RepositoryPickerFormField,
  margin: 'normal'
};
export default RepositoryPickerFormField;